// Types
import { GetAllHomePageData_featuredPpvEvents } from 'api/homePage/types/GetAllHomePageData';
import { GetFeaturedStreams } from 'api/homePage/types/GetFeaturedStreams';
import { StreamType } from 'api/graphql-global-types';
// Helpers
import { formatStreamDate } from 'helpers/dateText';
import { formatPriceToUSD, getStreamButtonText } from 'helpers/priceText';
import { computeOrderStreamPath } from 'helpers/routes';
import { getStreamDateShortFormat } from 'helpers/streams';
import { isTicketEventSelling } from 'helpers/ticketSales';

export type FeaturedStreamsType =
  | GetAllHomePageData_featuredPpvEvents
  | GetFeaturedStreams['featuredPpvEvents'][number];

type FeaturedStream = FeaturedStreamsType['stream'];

/** Both carousels' slide extras: its link, date tag, the organizer (Watch pages only) and tickets on sale. */
export const getFeaturedSlideDetails = (
  stream: FeaturedStream,
  withOrganizer: boolean
) => ({
  streamPath: computeOrderStreamPath(stream),
  dateLabel: withOrganizer
    ? getStreamDateShortFormat(stream.scheduleDateUtc)
    : formatStreamDate(stream.scheduleDateUtc),
  organizer:
    withOrganizer && stream.store && 'storeDetails' in stream.store
      ? stream.store
      : null,
  ticketEvent:
    'ticketEvent' in stream &&
    stream.ticketEvent &&
    isTicketEventSelling(stream.ticketEvent)
      ? stream.ticketEvent
      : null,
});

export const getFeaturedStreamActionState = (
  stream: FeaturedStream,
  userId?: string | null,
  showOfficialPpvTag = true
) => {
  const isInterview = stream.type === StreamType.Interview;
  // Auto-freed PPV keeps its original price, so `isFree` — not a zero price —
  // is what decides whether the slide is free to watch.
  const isFree =
    stream.isFree === true ||
    (stream.price != null && Number(stream.price) === 0);
  const isUserStreamCreator = userId === stream.store?.id;
  const hasAccessToWatch =
    isFree ||
    ('isPurchased' in stream && stream.isPurchased) ||
    isUserStreamCreator;

  return {
    hasAccessToWatch,
    isUserStreamCreator,
    showOfficialPpvTagForSlide: showOfficialPpvTag && !isInterview && !isFree,
    buttonText: getStreamButtonText(
      stream.price,
      formatPriceToUSD,
      isInterview,
      hasAccessToWatch
    ),
  };
};
